require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;



//////////////////
// WEBPACK FOOTER
// E:/java/gd-project/credit-gd-web/node_modules/core-js/es6/parse-int.js
// module id = ../../../../core-js/es6/parse-int.js
// module chunks = polyfills